export default __webpack_public_path__ + "static/media/stepRight.143feca5.svg";